import React from 'react';
import { useLocation } from 'react-router-dom';
import LanguageSync from './components/LanguageSync';

import './css/layout.css';
import './css/common.css';
import './css/main.css';
import './css/member.css';
import './css/table.css';
import './css/modal.css';

import Header from './components/header';
import Router from './common/router';
import Footer from './components/footer';

function App() {
  const location = useLocation();
  const isChromeless =
    location.pathname.startsWith('/popup') ||
    location.pathname.startsWith('/event');
  return (
    <>
      <LanguageSync />
      {!isChromeless && <Header />}
      <Router />

      {!isChromeless && <Footer />}
    </>
  );
}

export default App;
